export * from './UtilLog' // log打印
export * from './UtilReg' // 正则验证
export * from './UtilMisc' //杂项
export * from './UtilCoupon' //优惠券公共方法
export * from './UtilExt'
export { default as UtilPhone } from './UtilPhone' // 设备方法
